import { Component, OnInit, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'fyt-biometric-suggestion',
  templateUrl: './biometric-suggestion.component.html',
  styleUrls: ['./biometric-suggestion.component.css']
})
export class BiometricSuggestionComponent implements OnInit {
  @Output() onAction = new EventEmitter();
  @Input() callBackfun: (arg: any) => void;
  @Input() inputMsg: any;
  closeFlag: boolean = false;

  constructor() { }

  ngOnInit(): void {
    setTimeout(() => {
      this.closeDialog()
    }, 7000);
  }

  closeDialog() {
    this.closeFlag = false;
    this.onAction.emit({})
    this.callBackfun("")
  }

}
